import React from 'react';

import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

import appI18n from '../../../../config/i18n';

interface Props {
  associatedCount: number;
  referentialCapacity: number;
}

function CapacityAlert({ associatedCount, referentialCapacity }: Props) {
  const { t } = useTranslation(undefined, { i18n: appI18n });

  if (associatedCount < referentialCapacity) {
    return null;
  }

  const isExceeded = associatedCount > referentialCapacity;
  const messageKey = isExceeded
    ? 'scenes.requirements.detail.capacity.exceeded'
    : 'scenes.requirements.detail.capacity.reached';

  return (
    <Alert
      type={isExceeded ? 'error' : 'warning'}
      showIcon
      style={{ marginBottom: 12 }}
      message={t(messageKey, {
        count: associatedCount,
        capacity: referentialCapacity,
      })}
    />
  );
}

export default CapacityAlert;
